import { gql } from '@apollo/client';

export const UPDATE_USER_PREFERENCES = gql`
  mutation Flex_UpdateUserPreferences($input: UpdateUserPreferencesInput!) {
    updateUserPreferences(input: $input) {
      id
    }
  }
`;
